export const GET_ENROLLMENTS = "GET_ENROLLMENTS";
export const GET_ENROLLMENT_BY_ID = "GET_ENROLLMENT_BY_ID";
export const UPDATE_ENROLLMENT = "UPDATE_ENROLLMENT";
export const DELETE_ENROLLMENT = "DELETE_ENROLLMENT";
export const CREATE_ENROLLMENT = "CREATE_ENROLLMENT";
export const GET_ENROLLMENT_PROGRESS = "GET_ENROLLMENT_PROGRESS";
export const SET_ENROLLMENT_PROGRESS = "SET_ENROLLMENT_PROGRESS";
